import { useState } from "react";
import { Building2, ArrowUpRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

const BULK_URL = "https://escapemgm.com/Games";

export default function BulkEnquiry({ open, onOpenChange }) {
  const [form, setForm] = useState({ name: "", company: "", email: "", phone: "", team_size: "", message: "" });
  const [busy, setBusy] = useState(false);

  const go = () => window.open(BULK_URL, "_blank");

  const submit = async () => {
    if (!form.name || !form.email) return toast.error("Name and email are required");
    setBusy(true);
    try {
      await api.post("/leads", form);
      toast.success("Thanks! Taking you to our full games catalogue…");
      onOpenChange(false);
      go();
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#131a29] border-white/10 max-h-[92vh] overflow-y-auto" data-testid="bulk-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Building2 className="h-5 w-5 text-emerald-400" /> Corporate & bulk bookings</DialogTitle>
          <DialogDescription className="text-slate-400">Planning a team offsite or a large group? Drop your details and we'll take you to our full catalogue on escapemgm.com.</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 mt-2">
          <div className="grid grid-cols-2 gap-3">
            <Input placeholder="Your name*" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="bulk-name" className="bg-slate-950/50 border-white/10" />
            <Input placeholder="Company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} data-testid="bulk-company" className="bg-slate-950/50 border-white/10" />
            <Input placeholder="Email*" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="bulk-email" className="bg-slate-950/50 border-white/10" />
            <Input placeholder="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="bulk-phone" className="bg-slate-950/50 border-white/10" />
          </div>
          <Input placeholder="Approx team / group size" value={form.team_size} onChange={(e) => setForm({ ...form, team_size: e.target.value })} data-testid="bulk-size" className="bg-slate-950/50 border-white/10" />
          <Textarea placeholder="Anything else? (dates, location, requirements)" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="bulk-message" className="bg-slate-950/50 border-white/10" />
        </div>
        <div className="flex flex-col sm:flex-row gap-3 mt-3">
          <Button onClick={submit} disabled={busy} data-testid="bulk-submit" className="bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-bold flex-1">
            {busy ? <Loader2 className="h-4 w-4 animate-spin mr-2" /> : null} Submit & continue <ArrowUpRight className="h-4 w-4 ml-1" />
          </Button>
          <Button onClick={() => { onOpenChange(false); go(); }} variant="secondary" data-testid="bulk-skip">Skip & visit site</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
